import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20bc8ff8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-width" }
const _hoisted_2 = { class: "pvd3-grid-root full-width top-half" }
const _hoisted_3 = { class: "title-section" }
const _hoisted_4 = {
  slot: "heading",
  class: "pvd-title__heading pvd-title__heading--level-1"
}
const _hoisted_5 = { class: "pvd-grid__grid" }
const _hoisted_6 = { class: "pvd-grid__item pvd-grid__item--column-span-12 pvd-grid__item--column-span-6-at-768 pvd-grid__item--column-span-4-at-960 pvd-grid__item--column-span-4-at-1280" }
const _hoisted_7 = { class: "amount-section" }
const _hoisted_8 = { class: "regular-font" }
const _hoisted_9 = { class: "fdic-link" }
const _hoisted_10 = { class: "pvd-grid__item pvd-grid__item--column-span-12 pvd-grid__item--column-span-6-at-768 pvd-grid__item--column-span-4-at-960 pvd-grid__item--column-span-4-at-1280" }
const _hoisted_11 = {
  id: "time-period-slider-component",
  "data-cy": "time_period"
}
const _hoisted_12 = { class: "pvd-grid__item pvd-grid__item--column-span-12 pvd-grid__item--column-span-12-at-768 pvd-grid__item--column-span-4-at-960 pvd-grid__item--column-span-4-at-1280" }
const _hoisted_13 = {
  key: 0,
  id: "gs-timestamp-message",
  class: "gs-timestamp"
}
const _hoisted_14 = { class: "full-width bottom-half" }
const _hoisted_15 = { class: "pvd3-grid-root" }
const _hoisted_16 = {
  key: 0,
  class: "pvd-grid__grid card-section"
}
const _hoisted_17 = { class: "pvd-grid__item pvd-grid__item--column-span-12" }
const _hoisted_18 = {
  id: "card-section-title-id",
  class: "card-section-title"
}
const _hoisted_19 = { class: "pvd-grid__item pvd-grid__item--column-span-12" }
const _hoisted_20 = { class: "pvd-grid__item pvd-grid__item--column-span-12 pvd-grid__item--column-span-12-at-768 pvd-grid__item--column-span-8-at-960 pvd-grid__item--column-span-8-at-1280" }
const _hoisted_21 = {
  "data-cy": "top-bullets-container",
  class: "pvd-grid__item pvd-grid__item--column-span-12 pvd-grid__item--column-span-12-at-768 pvd-grid__item--column-span-4-at-960 pvd-grid__item--column-span-4-at-1280"
}
const _hoisted_22 = {
  key: 0,
  class: "side-bullets"
}
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 1,
  class: "side-bullets top-margin"
}
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = {
  key: 2,
  class: "side-bullets"
}
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "pvd-grid__item pvd-grid__item--column-span-12" }
const _hoisted_37 = { class: "pvd-grid__item pvd-grid__item--column-span-12 pvd-grid__item--column-span-6-at-768 pvd-grid__item--column-span-4-at-960 pvd-grid__item--column-span-4-at-1280" }
const _hoisted_38 = { class: "pvd-grid__item pvd-grid__item--column-span-12 pvd-grid__item--column-span-6-at-768 pvd-grid__item--column-span-4-at-960 pvd-grid__item--column-span-4-at-1280" }
const _hoisted_39 = {
  "data-cy": "bottom-bullets-container",
  class: "pvd-grid__item pvd-grid__item--column-span-12 pvd-grid__item--column-span-12-at-768 pvd-grid__item--column-span-4-at-960 pvd-grid__item--column-span-4-at-1280"
}
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = { class: "info-links-section" }
const _hoisted_49 = {
  key: 0,
  "aria-hidden": "true"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { "aria-hidden": "true" }, null, -1))
const _hoisted_51 = { class: "disclosure-section" }
const _hoisted_52 = { class: "disclosure-link" }
const _hoisted_53 = { class: "contact-us" }
const _hoisted_54 = { class: "disclosure-section" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumbs = _resolveComponent("BreadCrumbs")!
  const _component_pvd3_title = _resolveComponent("pvd3-title")!
  const _component_pvd3_label = _resolveComponent("pvd3-label")!
  const _component_apex3_currency = _resolveComponent("apex3-currency")!
  const _component_pvd3_inline_alert = _resolveComponent("pvd3-inline-alert")!
  const _component_pvd3_field_group = _resolveComponent("pvd3-field-group")!
  const _component_pvd3_link = _resolveComponent("pvd3-link")!
  const _component_FdicModal = _resolveComponent("FdicModal")!
  const _component_fractional_cd_slider = _resolveComponent("fractional-cd-slider")!
  const _component_pvd3_microcopy = _resolveComponent("pvd3-microcopy")!
  const _component_ScreenerCard = _resolveComponent("ScreenerCard")!
  const _component_ScreenerModal = _resolveComponent("ScreenerModal")!
  const _component_pvd3_button = _resolveComponent("pvd3-button")!
  const _component_pvd3_footnote = _resolveComponent("pvd3-footnote")!
  const _component_pvd3_footnotes = _resolveComponent("pvd3-footnotes")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BreadCrumbs, {
      linkList: _ctx.linkList,
      "show-action-links": false
    }, null, 8, ["linkList"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_pvd3_title, null, {
          default: _withCtx(() => [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.clientConstants.SCREENER_TITLE), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_pvd3_field_group, { "pvd-fixed-width": "true" }, {
              default: _withCtx(() => [
                _createVNode(_component_pvd3_label, {
                  id: "amount-label",
                  "data-cy": "amount-field-label",
                  "pvd-for": "investment-amount-input"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.clientConstants.SCREENER_INPUT_TITLE), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_apex3_currency, {
                  "data-cy": "amount-field-input",
                  label: "",
                  "id-prefix": "investment-amount",
                  error: _ctx.amountValueInvalid,
                  value: _ctx.formattedAmount,
                  onChange: _ctx.amountChange
                }, null, 8, ["error", "value", "onChange"]),
                _withDirectives(_createVNode(_component_pvd3_inline_alert, {
                  id: "amount-input-alert",
                  "pvd-size": "small",
                  "data-cy": "amount-input-alert"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.clientConstants.AMOUNT_CONTENT_INPUT_ERROR), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.amountValueInvalid]
                ]),
                _withDirectives(_createVNode(_component_pvd3_inline_alert, {
                  id: "amount-max-alert",
                  "pvd-size": "small",
                  "data-cy": "amount-max-alert"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.clientConstants.AMOUNT_CONTENT_MAX_LIMIT_ERROR), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.amountMaxExceeded]
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_pvd3_link, {
                id: "fdic-link",
                "pvd-trigger": "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.clientConstants.FDIC_LINK), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_FdicModal, { ref: "fdicModal" }, null, 512)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_fractional_cd_slider, {
              id: `time-period-slider`,
              values: _ctx.clientConstants.timePeriodList,
              currentValue: _ctx.durationIndex,
              onChange: _ctx.durationChange
            }, null, 8, ["values", "currentValue", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          (this.store.offeringsLoaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_pvd3_microcopy, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.timestampMessage), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        (this.offerings.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.cardSectionTitle), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_Transition, {
                  appear: "",
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("p", {
                      id: "option1-text-id",
                      key: _ctx.animationTrigger,
                      class: "option-text"
                    }, _toDisplayString(_ctx.option1Text), 1))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_Transition, {
                  appear: "",
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_ScreenerCard, {
                      idPrefix: "top",
                      cardStyle: _ctx.topCard.style,
                      cusip: _ctx.topCard.cusip,
                      duration: _ctx.topCard.duration,
                      apy: _ctx.topCard.apy,
                      returnAmount: this.formatDollarAmount(_ctx.topCard.returnAmount),
                      investmentAmount: _ctx.topCard.investmentAmount,
                      title: _ctx.topCard.title,
                      showFractionalIcon: _ctx.isTopCardFractionalCD,
                      key: _ctx.animationTrigger,
                      searchURL: _ctx.topCard.searchURL,
                      "data-cy": "screener-card-top"
                    }, null, 8, ["cardStyle", "cusip", "duration", "apy", "returnAmount", "investmentAmount", "title", "showFractionalIcon", "searchURL"]))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_Transition, {
                  appear: "",
                  name: "considerations-fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("div", { key: _ctx.animationTrigger }, [
                      (_ctx.isOptionAvailable)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [
                            _createElementVNode("li", { innerHTML: _ctx.considerations }, null, 8, _hoisted_23),
                            _createElementVNode("li", { innerHTML: _ctx.totalReturn }, null, 8, _hoisted_24),
                            _createElementVNode("li", { innerHTML: _ctx.oneTransaction }, null, 8, _hoisted_25),
                            _createElementVNode("li", { innerHTML: _ctx.oneDate }, null, 8, _hoisted_26),
                            (_ctx.isTopCardWholeCD)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 0,
                                  innerHTML: _ctx.mayBeCallable
                                }, null, 8, _hoisted_27))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isOptionAvailable && _ctx.isFractionalToWholeOpportunity)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_28, [
                            _createElementVNode("li", { innerHTML: _ctx.searchTips }, null, 8, _hoisted_29),
                            _createElementVNode("li", { innerHTML: _ctx.fractionalToWholeTip }, null, 8, _hoisted_30)
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.isOptionAvailable)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_31, [
                            _createElementVNode("li", { innerHTML: _ctx.searchTips }, null, 8, _hoisted_32),
                            (_ctx.isIncreaseOpportunity)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 0,
                                  innerHTML: _ctx.increaseInvestmentTip
                                }, null, 8, _hoisted_33))
                              : _createCommentVNode("", true),
                            (_ctx.isDecreaseOpportunity)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 1,
                                  innerHTML: _ctx.decreaseInvestmentTip
                                }, null, 8, _hoisted_34))
                              : _createCommentVNode("", true),
                            _createElementVNode("li", { innerHTML: _ctx.changeDurationTip }, null, 8, _hoisted_35)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  ]),
                  _: 1
                })
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_36, [
                _createVNode(_Transition, {
                  appear: "",
                  name: "fade-bottom",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("p", {
                      id: "option2-text-id",
                      key: _ctx.animationTrigger,
                      class: "option-2 option-text"
                    }, _toDisplayString(_ctx.option2Text), 1))
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.isMixedOpportunity]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_37, [
                _createVNode(_Transition, {
                  appear: "",
                  name: "fade-bottom",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_ScreenerCard, {
                      idPrefix: "whole",
                      cardStyle: _ctx.mixedWholeCard.style,
                      cusip: _ctx.mixedWholeCard.cusip,
                      duration: _ctx.mixedWholeCard.duration,
                      apy: _ctx.mixedWholeCard.apy,
                      returnAmount: this.formatDollarAmount(_ctx.mixedWholeCard.returnAmount),
                      title: _ctx.mixedWholeCard.title,
                      showFractionalIcon: false,
                      key: _ctx.animationTrigger,
                      searchURL: _ctx.mixedWholeCard.searchURL,
                      "data-cy": "screener-card-mixed-whole"
                    }, null, 8, ["cardStyle", "cusip", "duration", "apy", "returnAmount", "title", "searchURL"]))
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.isMixedOpportunity]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_38, [
                _createVNode(_Transition, {
                  appear: "",
                  name: "fade-bottom",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_ScreenerCard, {
                      idPrefix: "fractional",
                      cardStyle: _ctx.mixedFractionalCard.style,
                      cusip: _ctx.mixedFractionalCard.cusip,
                      duration: _ctx.mixedFractionalCard.duration,
                      apy: _ctx.mixedFractionalCard.apy,
                      returnAmount: _ctx.formatDollarAmount(_ctx.mixedFractionalCard.returnAmount),
                      title: _ctx.mixedFractionalCard.title,
                      showFractionalIcon: true,
                      key: _ctx.animationTrigger,
                      searchURL: _ctx.mixedFractionalCard.searchURL,
                      "data-cy": "screener-card-mixed-fractional"
                    }, null, 8, ["cardStyle", "cusip", "duration", "apy", "returnAmount", "title", "searchURL"]))
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.isMixedOpportunity]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_39, [
                _createVNode(_Transition, {
                  appear: "",
                  name: "considerations-fade-bottom",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("ul", {
                      class: "side-bullets",
                      key: _ctx.animationTrigger
                    }, [
                      _createElementVNode("li", { innerHTML: _ctx.considerations }, null, 8, _hoisted_40),
                      _createElementVNode("li", { innerHTML: _ctx.combinedReturn }, null, 8, _hoisted_41),
                      _createElementVNode("li", { innerHTML: _ctx.earnMore }, null, 8, _hoisted_42),
                      _createElementVNode("li", { innerHTML: _ctx.twoTransactions }, null, 8, _hoisted_43),
                      (_ctx.mixedWholeCard.maturityDate == _ctx.mixedFractionalCard.maturityDate)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 0,
                            innerHTML: _ctx.bothDates
                          }, null, 8, _hoisted_44))
                        : _createCommentVNode("", true),
                      (_ctx.mixedWholeCard.maturityDate != _ctx.mixedFractionalCard.maturityDate)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 1,
                            innerHTML: _ctx.fractionalDate
                          }, null, 8, _hoisted_45))
                        : _createCommentVNode("", true),
                      (_ctx.mixedWholeCard.maturityDate != _ctx.mixedFractionalCard.maturityDate)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 2,
                            innerHTML: _ctx.wholeDate
                          }, null, 8, _hoisted_46))
                        : _createCommentVNode("", true),
                      _createElementVNode("li", { innerHTML: _ctx.mayBeCallable }, null, 8, _hoisted_47)
                    ]))
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.isMixedOpportunity]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_48, [
          _createVNode(_component_pvd3_link, {
            "pvd-id": "screener_link1",
            "pvd-href": _ctx.fullOfferingsUrl,
            "pvd-new-window": ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.clientConstants.SCREENER_OFFERINGS_LINK), 1)
            ]),
            _: 1
          }, 8, ["pvd-href"]),
          (_ctx.isDesktopWidth)
            ? (_openBlock(), _createElementBlock("span", _hoisted_49, "|"))
            : _createCommentVNode("", true),
          _createVNode(_component_pvd3_link, {
            id: "screener-link-2",
            "data-cy": "screener_link2",
            "pvd-trigger": "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openScreenerModal()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.clientConstants.SCREENER_SELECT_LINK), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_ScreenerModal, { ref: "screenerModal" }, null, 512)
      ]),
      _hoisted_50,
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_pvd3_link, {
            "pvd-id": "view-important-info-link",
            "pvd-href": _ctx.fiCommonRiskUrl,
            "pvd-new-window": ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.clientConstants.SCREENER_DISCLOSURE_LINK), 1)
            ]),
            _: 1
          }, 8, ["pvd-href"])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createVNode(_component_pvd3_button, {
            "pvd-id": "contact-us-button",
            "pvd-href": _ctx.contactUsUrl,
            "pvd-new-window": "true",
            "pvd-variant": "secondary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.clientConstants.CONTACT_US), 1)
            ]),
            _: 1
          }, 8, ["pvd-href"])
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _createVNode(_component_pvd3_footnotes, null, {
          default: _withCtx(() => [
            _createVNode(_component_pvd3_footnote, null, {
              default: _withCtx(() => [
                _createVNode(_component_pvd3_microcopy, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.clientConstants.SCREENER_DISCLOSURE_ASTERICK), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_55,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disclosures, (disclosure) => {
              return (_openBlock(), _createBlock(_component_pvd3_footnote, {
                key: disclosure.text
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_pvd3_microcopy, {
                    innerHTML: disclosure.text,
                    "data-cy": "disclosure"
                  }, null, 8, ["innerHTML"]),
                  _hoisted_56
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}